import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyConfirmationModalModule } from '@vendasta/galaxy/confirmation-modal';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

export interface CancelOrderDialogData {
  isAdmin: boolean;
}

@Component({
  templateUrl: './cancel-order-dialog.component.html',
  styleUrl: './cancel-order-dialog.component.scss',
  imports: [
    GalaxyConfirmationModalModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    GalaxyFormFieldModule,
    GalaxyBadgeModule,
    FormsModule,
    TranslateModule,
  ],
})
export class CancelOrderDialogComponent implements OnInit {
  private isAdmin: boolean;
  titleText: string;
  bodyText: string;
  labelText: string;

  cancellationReason: string;

  constructor(
    private dialogRef: MatDialogRef<CancelOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: CancelOrderDialogData,
  ) {
    this.isAdmin = this.data.isAdmin;
  }

  ngOnInit(): void {
    this.titleText = 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.REQUEST_TO_CANCEL_ORDER.SALESPERSON.TITLE';
    if (this.isAdmin) {
      this.titleText = 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.REQUEST_TO_CANCEL_ORDER.ADMIN.TITLE';
    }
    this.bodyText = 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.REQUEST_TO_CANCEL_ORDER.SALESPERSON.MESSAGE';
    if (this.isAdmin) {
      this.bodyText = 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.REQUEST_TO_CANCEL_ORDER.ADMIN.MESSAGE';
    }
    this.labelText = 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.REQUEST_TO_CANCEL_ORDER.SALESPERSON.LABEL';
    if (this.isAdmin) {
      this.labelText = 'LIB_ORDERS.COMMON.ORDERS.DIALOGS.REQUEST_TO_CANCEL_ORDER.ADMIN.LABEL';
    }
  }

  onCancel(): void {
    this.dialogRef.close(this.cancellationReason);
  }

  onDontCancel(): void {
    this.dialogRef.close();
  }
}
